import { AppConfigActions } from "./app-config.actions";

export const initialState = {
  page: null,
  internetConnection: false,
  isOffline: false
};

export function AppConfigReducer(state: any = initialState, action) {
  switch (action.type) {
    case AppConfigActions.SET_PAGE:
      state.page = action.payload.page;
      return state;

    case AppConfigActions.SET_INTERNET_CONNECTION:
      state.internetConnection = action.payload.connection;
      return state;

    case AppConfigActions.TOGGLE_OFFLINE_MODE:
      state.isOffline = !state.isOffline
      return state;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/states/app/app-config.reducer.ts